import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Medicode = () => {
  const location = useLocation();
  const { state } = location;

  useEffect(() => {
    // 1) 특정 앵커로 스크롤 (기존 기능)
    if (state && state.someKey) {
      setTimeout(() => {
        const anchor = document.getElementById("scroll-witch");
        if (anchor) anchor.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }

    // 2) 최하단으로 스크롤 (새로 추가)
    if (state && state.scrollTo === "bottom") {
      setTimeout(() => {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: "smooth",
        });
      }, 100);
    }

    // reveal 애니메이션
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("is-in");
        });
      },
      { threshold: 0.14 }
    );
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [location, state]);

  return (
    <>
      <div className="pages-main-wrap">
        <div className="intro-top">
          <div className="page-tit">
            <div className="intro-wrapper">
              <h2>ABOUT US</h2>
            </div>
          </div>
          <div className="img-wrap"></div>
        </div>

        <div className="pages-inner-wrap">
          {/* ── Hero : 메인 슬로건 (동적 그라디언트 + 페이드 인) */}
          <section className="intro-hero reveal" id="intro">
            <h1 className="hero-title">
              의료의 신뢰와 기술의 혁신으로,
              <br />더 건강한 내일을 설계합니다.
            </h1>
            <p className="hero-desc">
              메디코드는 의료와 기술이 만나는 지점에서,
              <br />
              데이터를 연결하고 서비스를 더 편리하게 만듭니다.
            </p>

            {/* ✅ [추가] 네이버 “메디코드” 단독 인식용 (상단 1회 강하게) */}
            <p
              className="hero-brandline"
              style={{
                marginTop: 16,
                color: "rgba(255,255,255,0.78)",
                lineHeight: 1.7,
                fontSize: 15,
                letterSpacing: "-0.2px",
                textAlign: "center",
              }}
            >
              메디코드는 프리미엄 건강검진·의료 플랫폼입니다.
            </p>
          </section>

          {/* ── Story Blocks : Identity / Vision / Competence / What we do  */}
          <section className="story-circle reveal">
            {/* 중앙 코어 */}
            <div className="story-center">
              <p className="story-center-eyebrow">MEDICODE</p>
              <h3 className="story-center-title">Medical × Code</h3>
              <p className="story-center-desc">
                의료와 기술을 잇는 헬스케어 플랫폼
              </p>
            </div>

            {/* 위(0deg) - Vision */}
            <article className="story-node story-node--top">
              <h3 className="story-title">Our Vision</h3>
              <p className="story-lead">우리는 양보다 질에 집중합니다.</p>
              <ul className="story-list">
                <li>의료기관과의 협력으로 불필요한 비용을 줄이고,</li>
                <li>필요한 곳에 효율적으로 서비스를 제공합니다.</li>
              </ul>
            </article>

            {/* 오른쪽(90deg) - What we do */}
            <article className="story-node story-node--right">
              <h3 className="story-title">What We Do</h3>
              <p className="story-lead">건강검진의 접근성을 단순화합니다.</p>
              <ul className="story-list">
                <li>누구나 손쉽게 예약·관리할 수 있는 환경,</li>
                <li>파트너 맞춤형 플랫폼 솔루션을 제공합니다.</li>
              </ul>
            </article>

            {/* 아래(180deg) - Core competence */}
            <article className="story-node story-node--bottom">
              <h3 className="story-title">Core Competence</h3>
              <p className="story-lead">작지만 강한 팀, 빠른 실행.</p>
              <ul className="story-list">
                <li>플랫폼 · 의료서비스 · 영업마케팅의 유기적 협업,</li>
                <li>소통과 실행력으로 차별화된 결과를 만듭니다.</li>
              </ul>
            </article>

            {/* 왼쪽(270deg) - Identity */}
            <article className="story-node story-node--left">
              <h3 className="story-title">Our Identity</h3>
              <p className="story-lead">의료와 기술이 만나는 플랫폼</p>
              <ul className="story-list">
                <li>IT와 의료서비스의 융합으로</li>
                <li>양질의 의료를 더 많은 사람에게, 더 쉽게 연결합니다.</li>
              </ul>
            </article>
          </section>

          {/* ── MEDI + CODE (그대로) */}
          <section className="medi-code" id="medi-code">
            <div className="mc-head">
              <h2 className="mc-eyebrow">Our Philosophy</h2>
              <h3 className="mc-title">
                <span>MEDI</span> + <span>CODE</span>
              </h3>
              <p className="mc-sub">의료의 신뢰와 기술의 효율이 만나는 지점</p>
            </div>

            <div className="mc-grid">
              <div className="mc-card reveal">
                <div className="mc-sigil">M</div>
                <h4>MEDI (Medical)</h4>
                <p>의료의 신뢰, 임상·검진 데이터 네트워크</p>
                <ul>
                  <li>· 품질 검증된 파트너/기관</li>
                  <li>· 표준화된 리포트 & 데이터 정합성</li>
                  <li>· 환자/사용자 안전 중심 운영</li>
                </ul>
              </div>

              <div className="mc-operator">+</div>

              <div className="mc-card reveal">
                <div className="mc-sigil">&lt;/&gt;</div>
                <h4>CODE (System)</h4>
                <p>예약·결제·리포트, 연결을 위한 표준 API</p>
                <ul>
                  <li>· 커스터마이징 가능한 플랫폼</li>
                  <li>· 데이터 기반 의사결정</li>
                  <li>· 안정적 운영/보안</li>
                </ul>
              </div>

              <div className="mc-operator">=</div>

              <div className="mc-result reveal">
                <div className="mc-logo">MEDICODE</div>
                <p className="mc-claim">헬스케어 커넥션 플랫폼의 새로운 표준</p>
              </div>
            </div>

            <blockquote className="mc-quote">
              "Medical × Code" — 건강한 미래를 설계하는 연결의 프로토콜
            </blockquote>
          </section>
        </div>

        {/* 연혁 */}
        <section className="about-growth reveal">
          <h2 className="about-growth__title">
            빠르게 성장하는 헬스케어 커넥션 플랫폼
          </h2>
          <p className="about-growth__desc">
            메디코드는 의료기관, 파트너, 그리고 고객을 연결하며 빠르게 확장되는
            헬스케어 네트워크를 만들어가고 있습니다.
            <br />
            기술 중심의 예약 시스템과 데이터 기반 운영으로 매일 더 나은 서비스를
            완성해가고 있습니다.
          </p>
        </section>

        <section className="about-journey" id="about-journey">
          <h2 className="about-journey__title">Our Journey</h2>
          <p className="about-journey__subtitle">
            메디코드는 도전과 실행으로 꾸준히 성장하며,
            <br />
            새로운 변화를 만들어가고 있습니다.
          </p>

          <div className="about-journey__container">
            <div className="about-journey__line" />

            <ul className="about-journey__list">
              <li className="about-journey__item">
                <span className="about-journey__year">2025</span>
                <div className="about-journey__desc">
                  전국 제휴 네트워크 확장 및 보험채널 진출
                </div>
              </li>

              <li className="about-journey__item">
                <span className="about-journey__year">2024</span>
                <div className="about-journey__desc">
                  예약/정산 시스템 런칭 · 웨딩컨설팅 제휴 본격화
                  <br />
                  메디코드 설립 · 플랫폼 기획 및 병원 협력 구축
                </div>
              </li>
            </ul>
          </div>
        </section>

        {/* ── CTA : 리플렛/제안서 다운로드 */}
        <section className="cta-wrap" id="scroll-witch">
          {/* 회사소개서 */}
          <div className="cta-row cta-row--feature reveal">
            <div className="cta-left">
              <div className="badge">Company Deck</div>
            </div>
            <div className="cta-body">
              <h4 className="title">병원제안서</h4>
              <p className="desc">메디코드가 제안하는 병원 맞춤형 협력안</p>
            </div>
            <button
              className="cta-btn"
              onClick={() => {
                const a = document.createElement("a");
                a.href = "/files/메디코드 병원 제안서.pdf";
                a.download = "메디코드 병원 제안서.pdf";
                a.click();
              }}
            >
              다운로드
            </button>
          </div>

          {/* 웨딩컨설팅 제안서 */}
          <div className="cta-row reveal">
            <div className="cta-left">
              <div className="badge badge--alt">Wedding Deck</div>
            </div>
            <div className="cta-body">
              <h4 className="title">웨딩컨설팅 제안서</h4>
              <p className="desc">제휴/행사 파트너를 위한 제안 개요</p>
            </div>
            <button
              className="cta-btn"
              onClick={() => {
                const a = document.createElement("a");
                a.href = "/files/메디코드 웨딩컨설팅 제안서.pdf";
                a.download = "메디코드 웨딩컨설팅 제안서.pdf";
                a.click();
              }}
            >
              다운로드
            </button>
          </div>
        </section>

        {/* ✅ SEO 텍스트 섹션 (네이버 “메디코드” 인식용 / 디자인 영향 최소) */}
        <section
          className="medicode-seo-text"
          aria-label="메디코드 소개"
          style={{
            maxWidth: 960,
            margin: "120px auto 0",
            padding: "0 20px 120px",
            color: "rgba(255,255,255,0.72)",
            lineHeight: 1.9,
            fontSize: 15,
            letterSpacing: "-0.2px",
          }}
        >
          <h2 style={{ fontSize: 22, marginBottom: 14, color: "#fff" }}>
            메디코드
          </h2>

          <p style={{ marginBottom: 14 }}>
            <strong>메디코드</strong>는 프리미엄 건강검진 정보를 바탕으로
            사용자와 의료기관, 파트너를 연결하는 의료 플랫폼입니다. 건강검진
            예약과 관리 과정에서 발생하는 복잡한 선택을 줄이고, 필요한 정보를 더
            쉽게 이해할 수 있도록 돕는 것을 목표로 합니다.
          </p>

          <p style={{ marginBottom: 14 }}>
            메디코드는 여성검진, 종합검진, MRI·CT 검사 등 다양한 검진 분야에서
            신뢰할 수 있는 의료기관과의 협력을 기반으로 서비스를 확장합니다.
            이용자는 자신에게 필요한 검진 항목과 일정, 비용 정보를 비교하고
            확인할 수 있으며, 파트너는 운영에 필요한 예약·정산·관리 프로세스를
            효율적으로 구축할 수 있습니다.
          </p>

          <p style={{ marginBottom: 14 }}>
            메디코드는 의료의 신뢰와 기술의 효율을 결합합니다. 데이터 기반
            운영과 표준화된 시스템을 통해 예약부터 결제, 리포트까지 흐름을
            정돈하고, 이용자 경험을 더 편리하게 만듭니다. 작은 팀의 빠른
            실행력과 유기적인 협업으로 변화하는 시장에 민첩하게 대응하며
            서비스를 개선해 나갑니다.
          </p>

          <p style={{ marginBottom: 0 }}>
            메디코드는 건강한 삶을 위한 선택이 더 쉬워지도록, 의료 정보를
            투명하게 전달하고 접근성을 높이는 방향으로 성장합니다. 메디코드는
            의료와 기술이 만나는 지점에서 더 나은 건강검진 경험을 만들기 위해
            오늘도 연결을 확장하고 있습니다.
          </p>
        </section>
      </div>
    </>
  );
};

export default Medicode;
